<template>
  <div class="sl-step" :class="`is-${direction}`" :style="{ flexBasis:  spaceValue }">
    <div class="sl-step_head">
      <div class="sl-step_line"></div>
      <div class="sl-step_icon"></div>
    </div>
    <!-- <div class="sl-step_main">
      <div class="sl-step_left"></div>
      <div class="sl-step_right"></div>
    </div> -->
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "slStep",
  data(){
    return {
      direction: '',
    }
  },
  computed: {
    spaceValue(){
      const value = this.space
      if(typeof value == 'number'){
        return value + 'px'
      }
      return value
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    space: { //每个 step 的间距，不填写将自适应间距
      type: [Number , String],
      default: 0
    }
  },
  created(){
    // console.log(this.direction)
  }
}
</script>
<style scoped lang="scss">
  .sl-step {
    display: flex;
    position: relative;
    flex-shrink: 1;
    &.is-vertical {
      .sl-step_head {
        width: 100%;
        flex-grow: 0;
        position: relative;
        .sl-step_line {
          position: absolute;
          border-color: inherit;
          background-color: rgba(0,178,255,1);
          width: 2px;
          border-radius: 2px;
          top: 0;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
        .sl-step_icon {
          width: 4px;
          height: 4px;
          background:rgba(20,91,149,1);
          border:2px solid rgba(0,178,255,1);
          border-radius: 100%;
          position: absolute;
          top: -4px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    &.is-vertical {
      .sl-step_head {

      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Step/slStep.vue